import { create } from 'zustand';
import type { CitationData } from '../../components/yoda/components/Citation/types/citation';

interface CitationState {
  citations: CitationData[];
  isVisible: boolean;
  showCitations: (citations: CitationData[]) => void;
  hideCitations: () => void;
  reset: () => void;
}

export const useCitationStore = create<CitationState>(set => ({
  citations: [],
  isVisible: false,
  showCitations: (citations: CitationData[]) =>
    set({
      citations,
      isVisible: true,
    }),
  hideCitations: () =>
    set({
      isVisible: false,
      citations: [],
    }),
  reset: () =>
    set({
      citations: [],
      isVisible: false,
    }),
}));
